import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import List from './components/List'
import { paths } from '@/utils/path'
import Detail from './components/Detail'
import Update from './components/Update'
import CreateAddons from './components/CreateAddons'
import SLAConfig from './components/SLAConfig'
import SLADashboard from './components/SLA/Dashboard'

const ServiceModule: RouteObject = {
    path: 'services',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: paths.serviceDetail,
            element: <Detail />,
        },
        {
            // Standalone dashboard page (charts/widgets) — separate from
            // tab "Dịch vụ có SLA" which shows the customer-grouped service list
            path: 'sla-dashboard',
            element: <SLADashboard />,
        },
        {
            path: paths.serviceSLAConfig,
            element: <SLAConfig />,
        },
        {
            path: paths.serviceCreateAddons,
            element: <CreateAddons />,
        },
        {
            path: paths.serviceConfigEdit,
            element: <Update />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default ServiceModule
